import {LitElement, html, css} from 'lit';
import {navigator, router} from 'lit-element-router';
import {classMap} from 'lit/directives/class-map.js';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';

import {routeUrl} from '../../util/routeUrl';
import getRoutes from '../../routes';
import style from '../../../../scss/upgradeButton.scss';
import store from '../../store';
import {navigateTo} from '../../slices/statusSlice';

@customElement('arc-upgrade-button')
export class UpgradeButton extends connect(store)(navigator(router(LitElement))) {

	static styles = [style];

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.url = routeUrl('choose-plan', this.params, this.query);
	}
	static get routes() {
		return getRoutes();
	}
	router(route, params, query, data) {
		this.params = params;
		this.query = query;
	}
	render() {
		return html`
			<a @click="${this.linkClick}" class="upgradeLink" href="${this.url}">
				<span class="text">${msg('Upgrade')}</span>
			</a>
		`;
	}

	linkClick(event) {
		event.preventDefault();
		store.dispatch(navigateTo({route: 'plan', params: this.params, query: this.query}));
	}

}
